var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-article__hot-list" }, [
    _c("h1", { staticClass: "header" }, [_vm._v("热门视频")]),
    _vm._v(" "),
    _vm.list.length
      ? _c(
          "ul",
          {
            ref: "hotVideoListRef",
            staticClass: "hot-video-list",
            attrs: { "data-spm": "hot-feed" },
          },
          _vm._l(_vm.list, function (item) {
            return _c("li", { key: item.id }, [
              _c(
                "a",
                {
                  staticClass: "video-item",
                  attrs: { href: item.url, target: "_blank" },
                },
                [
                  _c("div", { staticClass: "img-box img-do" }, [
                    _c("div", { staticClass: "cover-layer" }),
                    _vm._v(" "),
                    _c("img", {
                      attrs: { src: item.cover && item.cover[0], alt: "" },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "video-info-tip" }, [
                      _vm._v(_vm._s(item.total)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "title-box" }, [
                    _c("p", { staticClass: "title" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(item.title) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                ]
              ),
            ])
          })
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoading
      ? _c("div", { staticClass: "more-load loading" }, [
          _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _vm._v("加载更多"),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isFinished
      ? _c("div", { staticClass: "more-load" }, [
          _vm._v("\n        已经到底了\n    "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }